"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const router_1 = require("../../router");
const ProvidersWrapper_1 = require("../ProvidersWrapper/ProvidersWrapper");
/**
 * Main template for pages in onboarding
 * This component uses ProvidersWrapper to provide context to the children
 *
 * @constructor
 */
function PageTemplate() {
    const location = (0, react_router_dom_1.useLocation)();
    /**
     * Whether to have space for the page navigator or use bigger padding
     * Currently, it's used only in ProfileSurveyTemplate
     */
    const hasPageNavigator = location.pathname.includes(router_1.Route.ProfileSurvey);
    const hasSubsheet = location.pathname.includes(router_1.Route.SubscriptionsSheet);
    return ((0, jsx_runtime_1.jsx)(ProvidersWrapper_1.ProvidersWrapper, { "data-e2e": 'PageTemplate_ProvidersWrapper', children: (0, jsx_runtime_1.jsx)(focus_trap_react_1.default, { "data-e2e": 'PageTemplate_FocusTrap', children: (0, jsx_runtime_1.jsx)(Wrapper, { "$hasPageNavigator": hasPageNavigator, "$hasSubsheet": hasSubsheet, "data-e2e": 'PageTemplate_Wrapper', children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, { "data-e2e": 'PageTemplate_Outlet' }) }) }) }));
}
exports.PageTemplate = PageTemplate;
const Wrapper = styled_components_1.default.div `
  position: absolute;
  z-index: 2;

  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  box-sizing: border-box;

  background: ${({ theme }) => theme.designSystem.background};

  ${({ $hasPageNavigator, $hasSubsheet }) => {
    if ($hasPageNavigator) {
        return (0, styled_components_1.css) `
        padding: 60px 40px 40px;

        ${ui_1.deviceLandscape.mobileS `
          padding: 40px;
        `}

        ${ui_1.device.laptopS `
          padding: 40px 80px 40px;
        `}
      `;
    }
    else {
        return (0, styled_components_1.css) `
        padding: 110px 40px 40px;

        ${ui_1.deviceLandscape.mobileS `
          padding: 78px 40px 40px;
        `}

        ${ui_1.device.laptopS `
          padding: 82px 80px 40px;
        `}

        ${$hasSubsheet &&
            ui_1.devicePortrait.mobileS `
          padding: 10px 20px 40px;
        `}

        ${$hasSubsheet &&
            ui_1.deviceLandscape.mobileS `
          padding: 20px 0px 40px;
        `}

        ${$hasSubsheet &&
            ui_1.device.laptopS `
          padding: 82px 0px 40px;
        `}
      `;
    }
}}
`;
